module.exports = __webpack_public_path__ + "assets/img/lu.bb098f06.png";